<div [ngStyle]="{
    'padding-top': component.componentSettings.padding_top + 'px',
    'padding-right': component.componentSettings.padding_right + 'px',
    'padding-bottom': component.componentSettings.padding_bottom + 'px',
    'padding-left': component.componentSettings.padding_left + 'px',
    'background-color': component.componentSettings.background_color,
    'border-radius': component.componentSettings.rounded_corners + 'px',
    height: component.componentSettings.height > 0 ? component.componentSettings.height + 'px' : 'auto'
  }">
  <button type="button" class="btn btn-light" style="float: right;" (click)="onRowAdd()">
    <i class="fa fa-add"></i>
  </button>
  <button type="button" class="btn btn-light" style="float: right;" (click)="onRowRemove()">
    <i class="fa fa-minus"></i>
  </button>

  <table [ngStyle]="{
      'border-radius': component.element.rounded_corners + 'px',
      'line-height': component.element.line_height,
      background: component.element.gradient_top_color
        ? 'linear-gradient(to top, ' +
          component.element.gradient_bottom_color +
          ', ' +
          component.element.gradient_top_color +
          ')'
        : component.element.button_color,
      height: component.element.height + 'px',
      width:
        component.element.button_size_type === 'full-width'
          ? '100%'
          : component.element.button_size_type === 'fixed'
          ? component.element.button_size + 'px'
          : 'auto',
      'box-shadow': component.element.box_shadow_color
        ? component.element.box_shadow_color + ' 0px -3px 0px 0px inset'
        : 'none',
      'border-width': component.element.border_width + 'px',
      'border-style': component.element.border_style,
      'border-color': component.element.border_color,
      'text-align': component.element.alignment,
      'table-layout': 'fixed'
    }" [align]="component.element.alignment">
    <thead>
      <th *ngFor="let column of component.element.columns" [ngStyle]="{
          'border-width': component.element.border_width + 'px',
          'border-style': component.element.border_style,
          'border-color': component.element.border_color,
          'text-align': component.element.alignment,
          'width': column.width + '%'
        }">{{column.name}}
      </th>
    </thead>
    <!-- this tr for preview -->
    <tr *ngIf="formState == null; else rowList">
      <td *ngFor="let column of component.element.columns" [ngStyle]="{
          'border-width': component.element.border_width + 'px',
          'border-style': component.element.border_style,
          'border-color': component.element.border_color,
          'text-align': component.element.alignment
        }">
        <ng-container [ngSwitch]="column.valueType">
          <input type="text" *ngSwitchCase="'text'" style="width: 100%" />
          <input type="checkbox" *ngSwitchCase="'checkbox'" class="form-check-input ms-0 me-2" />
          <input type="number" *ngSwitchCase="'number'" style="width: 100%" />
          <input type="date" *ngSwitchCase="'date'" style="width: 100%" />
          <div class="form-switch" *ngSwitchCase="'toggle'" style="width: 100%">
            <input class="form-check-input" role="switch" type="checkbox" />
          </div>
          <dx-select-box *ngSwitchCase="'dropdown'" [items]="column.options" displayExpr="value" valueExpr="value">
          </dx-select-box>
          <dx-number-box *ngSwitchCase="'amount'" format="#,##0.##"></dx-number-box>
        </ng-container>
      </td>
    </tr>
    <!-- this tr for form parser with state -->
    <ng-template #rowList>
      <tr *ngFor="let row of myState; let i = index">
        <td *ngFor="let column of component.element.columns" [ngStyle]="{
            'border-width': component.element.border_width + 'px',
            'border-style': component.element.border_style,
            'border-color': component.element.border_color,
            'text-align': component.element.alignment
          }">
          <ng-container [ngSwitch]="column.valueType">
            <input type="text" [value]="myState[i][column.name + '_' + column.id] || ''"
              (change)="onCellChange(i, column, $event)" *ngSwitchCase="'text'" style="width: 100%" />
            <input type="checkbox" [checked]="myState[i][column.name + '_' + column.id]"
              (change)="onCellChange(i, column, $event)" *ngSwitchCase="'checkbox'"
              class="form-check-input ms-0 me-2" />
            <input type="number" [value]="myState[i][column.name + '_' + column.id] || ''"
              (change)="onCellChange(i, column, $event)" *ngSwitchCase="'number'" style="width: 100%" />
            <input type="date" [value]="myState[i][column.name + '_' + column.id]"
              (change)="onCellChange(i, column, $event)" *ngSwitchCase="'date'" style="width: 100%" />
            <div class="form-switch" *ngSwitchCase="'toggle'" style="width: 100%">
              <input class="form-check-input" [checked]="myState[i][column.name + '_' + column.id]" role="switch"
                type="checkbox" (change)="onCellChange(i, column, $event)" />
            </div>
            <dx-select-box *ngSwitchCase="'dropdown'"
              (onValueChanged)="onCellChange(i, column, { target: { value: $event.value } })"
              [value]="myState[i][column.name + '_' + column.id]" [items]="column.options" displayExpr="value"
              valueExpr="value">
            </dx-select-box>
            <dx-number-box class="amountField" *ngSwitchCase="'amount'" [value]="myState[i][column.name + '_' + column.id]"
              format="#,##0.##" (onValueChanged)="onCellChange(i, column, { target: { value: $event.value } })">
            </dx-number-box>
          </ng-container>
        </td>
      </tr>
    </ng-template>
  </table>

  <div style="clear: both"></div>
</div>